<template>
  <div class="policy-card h-100" :class="{ 'is-active': isActive }">
    <div class="d-flex flex-column h-100 p-4">
      <div v-if="matchCount > 0" class="match-badge">
        {{ matchCount }}
      </div>

      <div>
        <h5 class="card-title">{{ groupName }}</h5>
        <hr class="card-separator" />
        <p class="card-desc">{{ description }}</p>
      </div>

      <div class="mt-auto">
        <hr class="card-separator" />
        <button
          class="btn control-list-btn w-100"
          type="button"
          @click="$emit('toggle')"
        >
          {{ isActive ? 'Close List of Policies' : 'Open List of Policies' }}
        </button>
      </div>
    </div>

    <div v-if="isActive" class="active-arrow"></div>
  </div>
</template>

<script>
export default {
  name: "PolicyGroupCard",
  props: {
    groupName: { type: String, required: true },
    description: { type: String, required: true },
    isActive: { type: Boolean, default: false },
    matchCount: { type: Number, default: 0 }
  },
  emits: ['toggle'],
};
</script>

<style scoped>
.policy-card {
  background: #FFFFFF;
  border: 1px solid #F5F5F5;
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  min-height: 220px;
  transition: all 0.2s ease-in-out;
  position: relative;
}

.policy-card.is-active {
  border-color: #00A0C1;
  box-shadow: 0px 10px 25px rgba(0, 160, 193, 0.2);
}

.active-arrow {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #00A0C1;
}

/* === BADGE REDESIGN STARTS HERE === */
.match-badge {
  position: absolute;
  /* MODIFICATION: Placed inside the card's padding area */
  top: 1rem;
  right: 1rem;
  /* MODIFICATION: Changed background color as requested */
  background-color: #F3994D;
  color: white;
  border-radius: 50%;
  /* MODIFICATION: Adjusted size for better balance */
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700; /* Using 700 for bold is common */
  box-shadow: 0px 2px 8px rgba(0,0,0,0.15);
}
/* === BADGE REDESIGN ENDS HERE === */

.card-title { font-family: 'Roboto', sans-serif; font-weight: 900; font-size: 16px; color: #435666; }
.card-separator { border-color: #D9D9D9; opacity: 1; }
.card-desc { font-family: 'Roboto', sans-serif; font-weight: 400; font-size: 14px; color: #435666; min-height: 52px; }
.control-list-btn { border: 1px solid #00A0C1; border-radius: 10px; color: #00A0C1; font-family: 'Roboto', sans-serif; font-weight: 900; font-size: 14px; background-color: #fff; }
.control-list-btn:hover { background-color: #00A0C1; color: #fff; }
</style>